app.service('dateHourMinuteGroup', function (localStorage) {

	function setTitle(){
		const copied = localStorage.getItem('copiedDateHourMinute');
		if (copied) {
			const { dayFrom, hourFrom, minuteFrom, dayTo, hourTo, minuteTo } = JSON.parse(copied);
			$('.js-paste-date').prop('title', 'Skopiowana data: ' + dayFrom + ' ' + hourFrom + ':' + minuteFrom + ' - ' + dayTo + ' ' + hourTo + ':' + minuteTo).prop('hidden', false);
		} else {
			$('.js-paste-date').prop('hidden', true);
		}
	}
	function init() {
		$('body').on('click', '.js-copy-date', function () {
			const $parentFrom = $(this).closest('.row-date-hour-minute');
			const dayFrom = $parentFrom.find('input[id*="-from-day"]').val();
			const hourFrom = $parentFrom.find('select[id*="-from-hour"]').val();
			const minuteFrom = $parentFrom.find('select[id*="-from-minute"]').val();
			const $parentTo = $parentFrom.next('.row-date-hour-minute');
			const dayTo = $parentTo.find('input[id*="-to-day"]').val();
			const hourTo = $parentTo.find('select[id*="-to-hour"]').val();
			const minuteTo = $parentTo.find('select[id*="-to-minute"]').val();
			localStorage.setItem('copiedDateHourMinute', JSON.stringify({
				dayFrom, hourFrom, minuteFrom, dayTo, hourTo, minuteTo
			}), 1); //przechowuj skopiowane daty przez 1 dzień
			setTitle();
		}).on('click', '.js-paste-date', function () {
			const $parentFrom = $(this).closest('.row-date-hour-minute');
			const $parentTo = $parentFrom.next('.row-date-hour-minute');
			const copied = localStorage.getItem('copiedDateHourMinute');
			if (copied) {
				const { dayFrom, hourFrom, minuteFrom, dayTo, hourTo, minuteTo } = JSON.parse(copied);
				$parentFrom.find('input[id*="-from-day"]').val(dayFrom);
				$parentFrom.find('select[id*="-from-hour"]').val(hourFrom);
				$parentFrom.find('select[id*="-from-minute"]').val(minuteFrom);
				$parentTo.find('input[id*="-to-day"]').val(dayTo);
				$parentTo.find('select[id*="-to-hour"]').val(hourTo);
				$parentTo.find('select[id*="-to-minute"]').val(minuteTo);
			} else {
				alert('Brak zapisanej pary dat do wklejenia. Najpierw skopiuj daty.');
			}
		});
		setTitle();
	}

	return {
		init
	}
});
